import {
  Box,
  Button,
  Collapse,
  ExpandMoreRoundedIcon,
  FilterListOutlinedIcon,
  Flex,
  Rotate,
  SearchInput,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useExamResultFileListSearchParams } from '../../hooks';

import ExamResultFileFilterForm from './exam-result-file-filter-form';

export default function ExamResultFileFilterSection() {
  const [{ search }, { changeSearch }] = useExamResultFileListSearchParams();
  const [isExpand, { toggle }] = useDisclosure(false);

  return (
    <>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ width: 300 }}>
          <SearchInput
            placeholder='ค้นหาชื่อไฟล์...'
            defaultValue={search ?? ''}
            onChange={changeSearch}
          />
        </Box>
        <Button
          variant='outlined'
          color='secondary'
          size='large'
          startIcon={<FilterListOutlinedIcon />}
          endIcon={
            <Rotate in={isExpand}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
          onClick={toggle}
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <ExamResultFileFilterForm />
      </Collapse>
    </>
  );
}
